module.exports = __webpack_public_path__ + "img/np-desktop.201b7350.webp";